<template>
  <div>
    <basic-container>
      <avue-crud
        :option="option"
        :data="copyList"
        ref="crud"
        @refresh-change="refreshChange"
        @selection-change="selectionChange"
        @select="select"
        @select-all="selectAll"
      >
        <!-- 自定义搜索框 -->
        <template slot="mySearch">
          <div class="search-contain">
            <div class="search-left">
              <div>
                <!-- 文件名称 -->
                <el-input
                  style="width: 200px !important; margin-right: 10px"
                  v-model="searchParams.search"
                  clearable
                  placeholder="文件名称"
                >
                </el-input>
                <!-- 状态 下拉筛选 单选 可清空 -->
                <!-- 0待上传 1上传中 2上传完成 3上传失败 4转码中 5转码完成 6转码失败 -->
                <el-select
                  style="width: 200px !important; margin-right: 10px"
                  v-model="searchParams.status"
                  placeholder="状态"
                  clearable
                >
                  <el-option label="待上传" value="0"></el-option>
                  <el-option label="上传中" value="1"></el-option>
                  <el-option label="上传完成" value="2"></el-option>
                  <el-option label="上传失败" value="3"></el-option>
                  <el-option label="转码中" value="4"></el-option>
                  <el-option label="转码完成" value="5"></el-option>
                  <el-option label="转码失败" value="6"></el-option>
                </el-select>
                <!-- 转码分组 下拉筛选 单选 可清空 -->
                <el-select
                  style="width: 200px !important; margin-right: 10px"
                  v-model="searchParams.aliyunTemplateId"
                  placeholder="转码分组"
                  clearable
                >
                  <el-option
                    v-for="item in templateGroup"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <!-- 批量处理 下拉筛选 单选 可清空 -->
                <el-select
                  style="width: 200px !important; margin-right: 10px"
                  v-model="searchParams.options"
                  placeholder="批量处理"
                  clearable
                >
                  <el-option label="批量复制链接" value="1"></el-option>
                  <el-option label="批量删除" value="2"></el-option>
                  <el-option label="批量下载" value="3"></el-option>
                </el-select>
                <div
                  style="
                    display: block;
                    width: 200px !important;
                    margin-right: 10px;
                  "
                ></div>
              </div>
              <div style="display: flex">
                <el-button
                  v-auth="'STORAGE_MANAGE_SEARCH'"
                  style="margin-right: 0.5%"
                  type="primary"
                  size="small"
                  @click="search"
                  >搜 索</el-button
                >
                <el-button
                  v-auth="'STORAGE_MANAGE_ADD_FILE'"
                  style="margin-right: 0.5%"
                  size="small"
                  @click="handleAdd"
                  >添加文件</el-button
                >
              </div>
            </div>
            <div class="search-left" style="margin-top: 10px"></div>
          </div>
        </template>
        <!-- 自定义表格列 -->
        <!-- TODO:把id换成文件名 -->
        <template #name="scope">
          <div style="display: flex">
            <div
              style="width: 100%"
              v-if="!scope.row.isEdit"
              @click="handleOpenEdit(scope.row)"
            >
              {{ scope.row.name }}
            </div>
            <el-input
              :class="'input-' + scope.row.id"
              v-if="scope.row.isEdit"
              v-model="scope.row.value"
              :placeholder="scope.row.name"
              size="mini"
              style="width: 100px"
              :disabled="scope.row.isLoading"
              @blur="handleBlur(scope.row)"
            >
            </el-input>
            <!-- 保存跟取消按钮 -->
            <div
              v-if="scope.row.isEdit"
              style="display: flex; margin-left: 10px"
            >
              <el-button
                size="mini"
                type="primary"
                :loading="scope.row.isLoading"
                @click="saveEdit(scope.row, $event)"
                >保存</el-button
              >
              <el-button size="mini" @click="scope.row.isEdit = false"
                >取消</el-button
              >
            </div>
          </div>
        </template>
        <!-- 自定义表格操作栏 -->
        <template #menu="{ row }">
          <el-button
            v-auth="'STORAGE_MANAGE_COPY_LINK'"
            v-clipboard:copy="row.playUrl"
            type="text"
            size="small"
            @click="copyLink"
            >复制链接</el-button
          >
          <el-button
            v-auth="'STORAGE_MANAGE_PREVIEW'"
            type="text"
            size="small"
            @click="handlePreview(row.playUrl)"
            >预览</el-button
          >
          <el-button
            v-auth="'STORAGE_MANAGE_DEL'"
            type="text"
            size="small"
            @click="handleDelete(row.id)"
          >
            删除
          </el-button>
        </template>
      </avue-crud>
      <ElementPagination
        style="margin-bottom: 20px"
        :current-page="searchParams.current"
        :page-size="searchParams.size"
        :total="searchParams.total"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </basic-container>
    <AddDialog
      ref="addDialog"
      :params="params"
      @refresh="
        () => {
          loadList()
        }
      "
    ></AddDialog>
  </div>
</template>

<script>
import ElementPagination from '@/components/ElementPagination'
import AddDialog from './components/add.vue'
import Message from '@/components/Message'
import options from './options'
import {
  getTemplateGroup,
  getFileList,
  updateFileName,
  delFile
} from '@/api/mediaManage/storageManage'
export default {
  name: 'WebSassIndex',
  components: {
    ElementPagination,
    AddDialog
  },
  data() {
    return {
      /** 转码模板分组 */
      templateGroup: [],
      /** 搜索参数 */
      searchParams: {
        search: '',
        status: '',
        options: '',
        aliyunTemplateId: '',
        size: 100,
        current: 1,
        total: 50
      },
      /** avue里面的表格 */
      list: [
        { id: 1, companyName: 'name', descr: '122' },
        { id: 2, companyName: 'name2', descr: '222' },
        { id: 3, companyName: 'name2', descr: '222' },
        { id: 4, companyName: 'name2', descr: '222' },
        { id: 5, companyName: 'name2', descr: '222' },
        { id: 6, companyName: 'name2', descr: '222' },
        { id: 7, companyName: 'name2', descr: '222' },
        { id: 8, companyName: 'name2', descr: '222' },
        { id: 9, companyName: 'name2', descr: '222' },
        { id: 10, companyName: 'name2', descr: '222' },
        { id: 11, companyName: 'name2', descr: '222' }
      ],
      copyList: [],
      /** 选中的list */
      selectedList: [],
      option: options(this)
    }
  },
  created() {
    this.loadList()
    this.getTemplateGroup()
  },
  watch: {
    'searchParams.options'(val) {
      console.log('searchParams.options', val)
      if (val === '1') {
        this.batchCopy()
      }
      if (val === '2') {
        this.batchDel()
      }
      if (val === '3') {
        this.batchDownload()
      }
    }
  },
  methods: {
    /** 批量复制 */
    batchCopy() {
      console.log('批量复制')
      /** 批量复制，在url之间加入换行符号 */
      let str = ''
      if (this.selectedList.length === 0) {
        Message.error('请勾选至少一条数据')
        return
      }
      /** 状态需要都为完成 */
      const isAllFinish = this.selectedList.every((item) => {
        return item.status === 5
      })
      if (!isAllFinish) {
        Message.error('数据状态需都为“完成”状态')
        return
      }
      this.selectedList.forEach((item) => {
        str += item.playUrl + '\n'
      })
      console.log('str', str)
      this.$copyText(str).then(() => {
        Message.success('复制成功')
      })
    },
    /** 批量下载 */
    batchDownload() {
      console.log('批量下载')
      if (this.selectedList.length === 0) {
        Message.error('请勾选至少一条数据')
        return
      }
      /** 批量下载，需要下载的文件的状态都为完成 */
      const isAllFinish = this.selectedList.every((item) => {
        return item.status === 5
      })
      if (!isAllFinish) {
        Message.error('数据状态需都为“完成”状态')
        return
      }
      /** 下载 */
      this.selectedList.forEach((item) => {
        this.downloadFile(item.playUrl, item.name)
      })
    },
    /** 批量删除 */
    async batchDel() {
      console.log('批量删除')
      const length = this.selectedList.length
      if (length === 0) {
        Message.error('请勾选至少一条数据')
        return
      }
      /** 二次询问 */
      this.$confirm(`此操作将永久删除${length}个文件, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          /** 调接口 */
          const ids = this.selectedList.map((item) => item.id).join(',')
          const { data } = await delFile(ids)
          if (data.code === 200) {
            Message.success('批量删除成功')
            this.loadList()
          }
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    /** 下载 */
    downloadFile(url, filename) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const a = document.createElement('a')
          const url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = filename
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        })
    },
    //^ ^--------------勾选表格事件触发-------------^ ^、
    /** 单选 */
    select(select, row) {
      const index = this.selectedList.findIndex((item) => item.id === row.id)
      /** 如果row 在val 列表里 说明是删除 否则是选中 */
      if (select.findIndex((item) => item.id === row.id) >= 0) {
        /** 选中的情况 （且选中这一项已经在this.mediaSelectList）  去重*/
        if (index >= 0) {
          this.selectedList.splice(index, 1, row)
        } else {
          /** 不在this.mediaSelectList 直接push */
          this.selectedList.push(row)
          row.isSelected = true
        }
      } else {
        /** 不是选中的情况 直接删除 */
        index >= 0 && this.selectedList.splice(index, 1)
      }
      console.log('selectedList', this.selectedList)
    },
    /** 全选 */
    selectAll(select) {
      console.log('全选', select)
      this.selectedList = select
    },
    /** 多选 */
    selectionChange(select) {
      console.log('多选', select)
    },

    // ^ ^--------------表格内的事件-------------^ ^
    /** 失焦 */
    handleBlur(row) {
      setTimeout(() => {
        if (!row.isLoading) {
          row.isEdit = false
          row.value = row.name
        }
      }, 1000)
    },
    /** 保存编辑 */
    async saveEdit(row) {
      try {
        row.isLoading = true
        const { data } = await updateFileName({
          id: row.id,
          name: row.value
        })
        if (data.code === 200) {
          Message.success('修改成功')
        }
        this.loadList()
        row.isEdit = false
      } finally {
        row.isLoading = false
      }
    },
    /** 打开编辑 */
    handleOpenEdit(row) {
      row.isEdit = true
      /** 把其他的编辑给关闭 */
      this.copyList.forEach((item) => {
        if (item.id !== row.id) {
          item.isEdit = false
        }
      })
      console.log('打开编辑', row)
      const element = document.querySelector(`input-${row.id}`)
      if (element) {
        element.focus()
      }
    },
    /** 复制链接 */
    copyLink() {
      Message.success('复制成功')
      console.log('复制链接')
    },
    /** 预览的事件 */
    handlePreview(url) {
      console.log('预览的事件')
      //TODO:传入url
      this.handleAlertPreview(url)
    },
    /** 删除的事件 */
    handleDelete(id) {
      console.log('删除的事件')
      //TODO:调接口 更新数据 提示用户
      /** 二次询问 */
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          /** 调接口 */
          const { data } = await delFile(id)
          if (data.code === 200) {
            Message.success('删除成功')
            this.loadList()
            /** 从selectedList里面移除 */
            const index = this.selectedList.findIndex((item) => item.id === id)
            if (index >= 0) {
              this.selectedList.splice(index, 1)
            }
          }
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    /** 新增的事件 */
    handleAdd() {
      this.$refs.addDialog.show(this.templateGroup)
    },
    /** 预览弹窗的方法 */
    handleAlertPreview(url) {
      if (!url) {
        Message.error('url地址为空')
        return
      }
      let _dom = 'video controls'
      this.$alert(
        `<${_dom} src='` + `${url}` + "' style='width:100%'>",
        '图片/视频展示',
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: true,
          customClass: 'showImage',
          callback: () => {
            // 在弹窗关闭时执行停止视频播放的操作
            const videoElement = document.querySelector('.showImage video')
            if (videoElement) {
              videoElement.pause()
            }
          }
        }
      )
    },
    //^ ^--------------分页相关-------------^ ^

    /** 分页 */
    async loadList() {
      console.log('分页参数', this.searchParams)
      const { data } = await getFileList(this.searchParams)
      this.list = data.data.records
      /** 合并数组 */
      this.copyList = this.list.map((item) => {
        return {
          ...item,
          ref: null,
          isLoading: false,
          isEdit: false,
          value: item.name,
          isSelected: false
        }
      })
      this.searchParams.total = data.data.total
      /** 回填表格的选中态 */

      this.$nextTick(() => {
        let list = []
        this.selectedList.forEach((item) => {
          const index = this.copyList.findIndex((i) => i.id === item.id)
          if (index >= 0) {
            list.push(this.copyList[index])
          }
        })
        console.log('回填表格的选中态', list)
        list.forEach((item) => {
          this.$refs.crud.toggleRowSelection(item, true)
        })
      })
      console.log('获取文件列表的响应', data)
    },
    /** 搜索的事件 */
    search() {
      Message.success('搜索成功')
      console.log('搜索的事件')
      this.loadList()
    },
    /** avue的刷新事件 */
    refreshChange() {
      console.log('avue的刷新事件')
      // this.loadList();
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val
      Message.success(`每页 ${val} 条`)
      /** 更新数据 */
      this.loadList()
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val

      Message.success(`当前页 ${val}`)
      /** 更新数据 */
      this.loadList()
    },
    //^ ^--------------数据准备-------------^ ^
    /** 获取业务字典里面的转码模板分组 */
    async getTemplateGroup() {
      const { data } = await getTemplateGroup()
      console.log('获取转码分组的响应', data)
      this.templateGroup = data.data.map((item) => {
        return {
          id: item.id,
          label: item.dictValue,
          value: item.dictKey
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-left {
  width: 100%;
  display: flex !important;
  // flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.flex {
  margin-top: 10px;
  padding: 2% 15%;
  width: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap !important;
  background-color: #f7f7f7;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}

.detail-dialog-contain {
  background-color: #f7f7f7;
  padding: 0 10%;
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep
  .avue-crud
  .avue-crud__search
  .avue-form
  .avue-form__group
  .avue-form__row
  .el-form-item
  label {
  float: none;
  display: inline-block;
}

::v-deep .avue-crud__menu {
  position: relative;
  overflow: visible;

  .avue-crud__left {
    position: relative;

    .el-button {
      display: none;
      position: absolute;
      top: -4.5vw;
      left: 72vw;

      span {
        margin: 0;
      }

      .el-icon-download {
        display: none;
      }
    }
  }
}

::v-deep .el-card .is-never-shadow {
  overflow: visible !important;
}
</style>
